(function() { window.GUID_5b1037c8_e8cc_46ae_b188_18e5078ed9e7 = { getGuid: function() { return "5b1037c8-e8cc-46ae-b188-18e5078ed9e7"; } }; })();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var BgTasksSignalR;
(function (BgTasksSignalR) {
    $(function () {
        let bgTasksHubConnection = null;
        let isDisconnected = false;
        let isReconnected = false;
        let lastTimeout = null;
        function initSignalR() {
            return __awaiter(this, void 0, void 0, function* () {
                if (!bgTasksHubConnection && $('#LoggedUserRowId').length > 0 && $('#LoggedUserRowId').val() > 0 && typeof signalR !== 'undefined') {
                    bgTasksHubConnection = new signalR.HubConnectionBuilder()
                        .withUrl("/signalr/WebAppBgTasksHub")
                        .configureLogging(this.Logging ? signalR.LogLevel.Information : signalR.LogLevel.None)
                        .withAutomaticReconnect()
                        .build();
                    //bgTasksHubConnection.on("taskCompleted", function (e: IBgTask)  {
                    //    alert(e.taskId + " " + e.taskName);
                    //});
                    //bgTasksHubConnection.onreconnecting(error => {
                    //    isDisconnected = true;
                    //    isReconnected = false;
                    //    reconnectHub();
                    //});
                    //bgTasksHubConnection.onreconnected(connectionId => {
                    //});
                    yield connectHub();
                }
            });
        }
        //async function reconnectHub() {
        //    if (isReconnected) {
        //        return;
        //    }
        //    if (lastTimeout) {
        //        clearTimeout(lastTimeout);
        //    }
        //    lastTimeout = setTimeout(async () => {
        //        if (isReconnected) {
        //            return;
        //        }
        //        await connectHub();
        //        reconnectHub();
        //    }, 5000);
        //}
        function connectHub() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    yield bgTasksHubConnection.start();
                    let userId = parseInt($('#LoggedUserRowId').val());
                    yield bgTasksHubConnection.invoke('joinHub', userId);
                }
                catch (err) {
                    //reconnectHub();
                }
            });
        }
        initSignalR();
    });
})(BgTasksSignalR || (BgTasksSignalR = {}));

//# sourceMappingURL=BgTasksSignalR.js.map
